<template>
    <div class="container">
        <FullPageLoading
            :show="showLoading"
            :label="labelLoading"
        />
        <div class="col-12 profile p-3">
            <div class="bg-white br bs">
                <div class="profile__header">
                    <img class="br" src="@/assets/img/img-1.jpg" alt="Background">
                    <div class="profile__avatar">
                        <img v-if="dataUserVisit !== null" :src="dataUserVisit.photo_profile || '@/assets/img/hopper.jpg'" alt="Avatar">
                        <img v-else :src="dataUser.photo_profile || '@/assets/img/hopper.jpg'" alt="Avatar">
                    </div>
                </div>
                <div class="d-flex flex-column text-center">
                    <div class="profile__info p-4">
                        <h2 v-if="dataUserVisit !== null">{{ dataUserVisit.full_name }}</h2>
                        <h2 v-else>{{ dataUser.full_name }}</h2>
                        <b-form-input 
                            v-show="bio.edit === true && dataUserVisit === null" 
                            v-model="bio.text" 
                            type="text" 
                            @blur="bio.edit = false" 
                            @keyup.enter="bio.edit = false" 
                            :placeholder="(bio.text === null && bio.text === null) ? 'Please fill your Bio Profile... (Double Click Here)' : ''" 
                        />
                        <p 
                            v-show="bio.edit === false || dataUserVisit !== null" 
                            @dblclick="bio.edit = true"
                        >
                            {{ (bio.text === null || bio.text === '') ? '' : bio.text }}
                        </p>
                    </div>
                    <!-- TABS -->
                    <div class="d-flex profile__tabs">
                        <a @click="toTimeline" :class="{ col: true, 'p-4': true, active: isActiveTimeline}">Timeline</a>
                        <a @click="toPhotos" :class="{ col: true, 'p-4': true, active: isActivePhotos}">Photos & Videos</a>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="modal-report" title="Report Post">
            <b-form-textarea
                v-model="formReport.description"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
            />
            <template v-slot:modal-footer>
                <b-button @click="onCancelReport">Cancel</b-button>
                <b-button variant="primary" @click="onSendReport" class="ml-2">Send</b-button>
            </template>
            <template v-slot:modal-header>
                <h3>Report Post</h3>
            </template>
        </b-modal>
        <b-modal id="modal-share" title="Share Post">
            <b-form-textarea
                v-model="formShare.status"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
            />
            <template v-slot:modal-footer>
                <b-button @click="onCancelShare">Cancel</b-button>
                <b-button variant="primary" @click="onShareConfirm" class="ml-2">Share</b-button>
            </template>
            <template v-slot:modal-header>
                <h3>Share Post</h3>
            </template>
        </b-modal>

        <div class="row p-3 align-items-start">
            <div v-if="isActiveTimeline" class="col-12 d-block">
                <div class="col-12 col-md-9 col-lg-8 newsfeed float-left">
                    <div class="d-flex flex-column">
                        <!-- Newsfeed Posts -->
                        <div class="card" v-for="(item, i) in item" :key="item.id">
                            <div class="card__header d-flex align-items-center">
                                <img :src="item.user.photo_profile" alt="Avatar">
                                <div class="d-flex flex-column">
                                    <div>
                                        <a href="#" class="link semi-bold">{{ item.user.full_name }}</a>
                                    </div>
                                    <div class="d-flex">
                                        <small><i class="fas fa-clock"></i> {{ item.created_at | fromNow }}</small>
                                        &nbsp;
                                        <small
                                            v-if="item.person_tag !== null"
                                            v-html="personTagPill(item.person_tag)"
                                        ></small>
                                    </div>
                                </div>
                            </div>
                            <div class="card__content">
                                <div class="card__content__status" style="white-space: pre-line;">
                                    {{ item.status }}
                                    <div class="card my-2" v-if="item.shared_post_id !== 0">
                                        <div class="card__header d-flex align-items-center">
                                            <img :src="item.shared_post.user.photo_profile" alt="Avatar">
                                            <div class="d-flex flex-column">
                                                <div>
                                                    <a v-if="item.shared_post.user.id !== dataUser.id" @click="visitProfile(item.shared_post.user.id, item.shared_post.user.full_name)" class="link semi-bold">{{ item.shared_post.user.full_name }}</a>
                                                    <p v-else class="link semi-bold">{{ item.shared_post.user.full_name }}</p>
                                                </div>
                                                <div class="d-flex">
                                                    <small><i class="fas fa-clock"></i> {{ item.shared_post.created_at | fromNow }}</small>
                                                    &nbsp;
                                                    <small
                                                        v-if="item.person_tag !== null"
                                                        v-html="personTagPill(item.shared_post.person_tag)"
                                                    ></small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__content__status" style="white-space: pre-line;">
                                                {{ item.shared_post.status }}
                                                <div class="card__content__images" v-if="item.shared_post.media.length > 0">
                                                    <div class="row">
                                                        <div class="col" v-for="p in item.shared_post.media" :key="p.id" @click="showGalleryItem(item.shared_post.id)">
                                                            <img v-if="p.type === 'photo'" :src="p.url" :alt="item.shared_post.user.full_name + item.shared_post.id">
                                                            <video v-else width="320" height="240" controls>
                                                                <source :src="p.url">
                                                                Your browser does not support playing video.
                                                            </video>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card__content__utils">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <ul class="list-inline">
                                                            <li class="list-inline-item" v-if="item.shared_post.likes.length > 0"><i class="far fa-thumbs-up" style="color:blue;"></i> {{ item.shared_post.likes.length }} </li>
                                                            <li class="list-inline-item" v-else><i class="far fa-thumbs-up"></i> {{ item.shared_post.likes.length }} </li>

                                                            <li class="list-inline-item" v-if="item.shared_post.dislikes.length > 0"><i class="far fa-thumbs-down" style="color:red;"></i> {{ item.shared_post.dislikes.length }} </li>
                                                            <li class="list-inline-item" v-else><i class="far fa-thumbs-down"></i> {{ item.shared_post.dislikes.length }} </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__content__images" v-if="item.media.length > 0">
                                    <div class="row">
                                        <div class="col" v-for="p in item.media" :key="p.id" @click="showGallery(item.id)">
                                            <img v-if="p.type === 'photo'" :src="p.url" :alt="item.user.full_name + item.id">
                                            <video v-else width="320" height="240" controls>
                                                <source :src="p.url">
                                                Your browser does not support playing video.
                                            </video>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__content__utils">
                                    <div class="row">
                                        <div class="col-6">
                                            <ul class="list-inline">
                                                <li class="list-inline-item" v-if="isLiked(item.id, i)" @click="onLike(item.id, i)"><i class="far fa-thumbs-up" style="cursor: pointer;color:blue;"></i> {{ item.likes.length }} </li>
                                                <li class="list-inline-item" v-else @click="onLike(item.id, i)"><i class="far fa-thumbs-up" style="cursor: pointer;"></i> {{ item.likes.length }} </li>

                                                <li class="list-inline-item" v-if="isDisliked(item.id, i)" @click="onDislike(item.id, i)"><i class="far fa-thumbs-down" style="cursor: pointer;color:red;"></i> {{ item.dislikes.length }} </li>
                                                <li class="list-inline-item" v-else @click="onDislike(item.id, i)"><i class="far fa-thumbs-down" style="cursor: pointer;"></i> {{ item.dislikes.length }} </li>
                                            </ul>
                                        </div>
                                        <div class="col-6 text-right">
                                            <ul class="list-inline">
                                                <li v-if="item.shared_post_id === 0" class="list-inline-item" v-b-modal="'modal-share'" @click="onShare(item.id, item.user.full_name)"><a class="share-btn"><i class="far fa-share-square"></i> Share</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card__footer">
                                <div class="comments__section">
                                    <div class="comments d-flex align-items-start" v-for="c in item.comments" :key="c.id">
                                        <img class="comments__avatar" :src="c.user.photo_profile" alt="Avatar Comment">
                                        <div class="d-flex flex-column comments__content">
                                            <div class="d-flex justify-content-between">
                                                <a class="link semi-bold" href="#">{{ c.user.full_name }}</a>
                                            </div>
                                            <small class="f-grey"><i class="fas fa-clock"></i> {{ c.created_at | fromNow }}</small>
                                            <br>
                                            <p style="white-space: pre-line;">{{ c.status }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="comments__control">
                                    <input type="text" placeholder="Write a comment .." v-model="formComment[i].status" @keyup.enter="createComment(item.id, i)">
                                    <div class="comments__buttons" style="z-index: 9999 !important;">
                                        <button @click="toogleDialogEmojiComment(i)"><i class="far fa-smile"></i></button>
                                        <div :hidden="dialogHiddenComment(i)" class="emojiPicker">
                                            <VEmojiPicker :pack="emojisNative" labelSearch @select="onSelectEmojiComment" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card__option" data-toggle="toggle-option">
                                <b-dropdown variant="link" class="m-2" no-caret style="text-decoration: none;">
                                    <template v-slot:button-content>
                                        <i class="fa fa-ellipsis-v"></i>
                                    </template>
                                    <b-dropdown-item v-b-modal="'modal-report'" @click="onReport(item.id)">Report Post</b-dropdown-item>
                                    <b-dropdown-item @click="onDeletePost(item.id)">Delete Post</b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                        <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
                        <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
                            <span slot="no-more">
                                <!-- <div class="card">
                                    <div class="card__content">
                                        <div class="card__content__status" style="white-space: pre-line;">
                                            <h5 class="m-0">You already reach the last post!</h5>
                                        </div>
                                    </div>
                                </div> -->
                            </span>
                            <span slot="no-results">
                                <div class="mt-4" style="white-space: pre-line;">
                                    <img src="@/assets/img/post.png" alt="Empty Post" width="200">
                                    <p class="m-0 text-secondary" v-if="dataUserVisit !== null">{{ dataUserVisit.full_name }} don't post anything yet</p>
                                    <p class="m-0 text-secondary" v-else>You don't post anything yet</p>
                                </div>
                            </span>
                        </infinite-loading>
                        <!-- End of Newsfeed Posts -->
                    </div>
                </div>
                <div class="profile__more-info col-12 col-md-3 col-lg-4 bg-white p-2 br bs float-left">
                    <ul class="list-group">
                        <li class="list-group-item" v-for="i in profileItem" :key="i.field"><small class="text-secondary"><i>{{ i.field }}</i></small><br>{{ i.value }}</li>
                    </ul>
                </div>
            </div>

            <div class="col-12 col-md-12 col-lg-12 newsfeed" v-else>
                <div v-if="assetImage.length > 0" class="mb-5 p-5 card">    
                    <h4>Photos</h4>
                    <div class="row">
                        <div
                            v-for="(image, imageIndex) in assetImage"
                            :key="imageIndex"
                            :class="{col: imageIndex === 0 || imageIndex % 3 !== 0, 'w-100':imageIndex !== 0 && imageIndex % 3 === 0}"
                        >    
                            <img 
                                :src="image" 
                                :alt="imageIndex" 
                                class="img-fluid"
                                @click="indexAsset = imageIndex"
                            >
                        </div>
                    </div>
                </div>
                <div v-else class="mb-5 p-5 text-center card">
                    <img src="@/assets/img/selfie.png" class="ml-auto mr-auto" alt="Empty" width="200">
                    <p class="text-secondary">You don't have any photos yet</p>
                </div>

                <div v-if="assetVideo.length > 0" class="card p-5">
                    <h4>Videos</h4>
                    <div class="row">
                        <div
                            v-for="(video, videoIndex) in assetVideo"
                            :key="videoIndex"
                            :class="{col: videoIndex === 0 || videoIndex % 3 !== 0, 'w-100':videoIndex !== 0 && videoIndex % 3 === 0}"
                        >
                            <video width="320" height="240" controls>
                                <source :src="video.url">
                                Your browser does not support playing video.
                            </video>
                        </div>
                    </div>
                </div>
                <div v-else class="card p-5 text-center">
                    <img src="@/assets/img/video.png" class="ml-auto mr-auto" alt="Empty" width="200">
                    <p class="text-secondary">You don't have any videos yet</p>
                </div>
            </div>
            
            <gallery :images="assetImage" :index="indexAsset" @close="indexAsset = null"></gallery>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading';
import VueGallerySlideshow from 'vue-gallery-slideshow';
import packData from 'v-emoji-picker/data/emojis.json';
import FullPageLoading from './FullPageLoading.vue'
import VEmojiPicker from 'v-emoji-picker';
const CryptoJS = require("crypto-js");
const config = require('../config/config.js');
const { aes } = config;
import VueGallery from 'vue-gallery';

export default {
    components: {
        InfiniteLoading,
        VueGallerySlideshow,
        VEmojiPicker,
        FullPageLoading,
        'gallery': VueGallery,
    },
    data(){
        return {
            profileHeader: './../assets/img/img-1.jpg',
            bio: {
                text: '',
                edit: false,
            },
            formReport: {
                description: ''
            },
            formComment: [],
            formShare: {
                status: ''
            },
            dialogHiddenCommentID: '',
            editField: '',
            showLoading: false,
            isActiveTimeline: false,
            isActivePhotos: false,
            mostDislikedPostItem: null,
            mostSharedPostItem: null,
            labelLoading: 'Please Wait...',
            item: [],
            images: [],
            profileItem: [],
            assetImage: [],
            assetVideo: [],
            index: null,
            indexAsset: null,
            page: 0,
        }
    },
    computed: {
        profileHeaderURL: function(){
            return 'url(' + this.profileHeader + ')'
        },
        isLogin: function () {
            return this.$store.state.isLogin;
        },
        dataUser: function () {
            if (this.isLogin) {
                return this.$store.state.dataUser;
            } else {
                return [];
            }
        },
        dataUserVisit: function () {
            if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== null) {
                let bytes = CryptoJS.AES.decrypt(localStorage.getItem('visitProfileData').toString(), aes);
                let dataUser = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                return dataUser;
            } else {
                return null;
            }
        },
        emojisNative() {
            return packData;
        },
    },
    watch: {
        'bio.edit': function (newVal) {
            if (newVal === false) {
                this.updateProfile();
            }
        },
        '$route.params': {
            handler(newValue) {
                if (newValue.type === 'timeline') {
                    this.isActiveTimeline = true;
                    this.isActivePhotos = false;
                    if (typeof newValue.id !== 'undefined') {
                        this.profileItem = [];
                        this.load();
                        this.page = 0;
                        this.item = [];
                        this.formComment = [];
                        this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                    }
                } else {
                    this.showLoading = true;
                    this.labelLoading = 'Getting Photos & Videos! Please Wait...';
                    this.isActiveTimeline = false;
                    this.isActivePhotos = true;
                    this.onGetAsset();
                }
            },
            immediate: true,
        }
    },
    filters: {
        fromNow: function(val) {
            return moment(val).fromNow();
        },
        personTag: function(val) {
            let p = JSON.parse(val);
            let html = '';
            p.forEach((user) => {
                html += `<b-badge pill variant="primary">${user}</b-badge> `;
            });
            return html;
        },
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            if (this.dataUserVisit !== null) {
                this.bio.text = this.dataUserVisit.bio;

                if (this.dataUserVisit.origin_country !== null && this.dataUserVisit.origin_country !== '') {
                    this.profileItem.push({
                        field: 'Origin Country',
                        value: this.dataUserVisit.origin_country,
                    });
                }
                if (this.dataUserVisit.passport_no !== null && this.dataUserVisit.passport_no !== '') {
                    this.profileItem.push({
                        field: 'Passport No',
                        value: this.dataUserVisit.passport_no,
                    });
                }
                if (this.dataUserVisit.birthdate !== null && this.dataUserVisit.birthdate !== '') {
                    if (this.dataUserVisit.hide_birthdate !== 0) {
                        this.profileItem.push({
                            field: 'Birthdate',
                            value: moment(this.dataUserVisit.birthdate, 'DD-MM-YYYY').format(),
                        });
                    }
                }
                if (this.dataUserVisit.gender !== null && this.dataUserVisit.gender !== '') {
                    if (this.dataUserVisit.hide_gender !== 0) {
                        this.profileItem.push({
                            field: 'Gender',
                            value: this.dataUserVisit.gender,
                        });
                    }
                }
                if (this.dataUserVisit.phone_number !== null && this.dataUserVisit.phone_number !== '') {
                    if (this.dataUserVisit.hide_phone_number !== 0) {
                        this.profileItem.push({
                            field: 'Phone Number',
                            value: this.dataUserVisit.phone_number,             
                        });
                    }
                }
                if (this.dataUserVisit.darmasiswa_academic_year !== null && this.dataUserVisit.darmasiswa_academic_year !== '') {
                    this.profileItem.push({
                        field: 'Darmasiswa Academic Year',
                        value: this.dataUserVisit.darmasiswa_academic_year,
                    });
                }
                if (this.dataUserVisit.field_study !== null && this.dataUserVisit.field_study !== '' && this.dataUserVisit.field_study !== 'default') {
                    this.profileItem.push({
                        field: 'Field Study',
                        value: this.dataUserVisit.field_study,
                    });
                }
                if (this.dataUserVisit.university !== null && this.dataUserVisit.university !== '') {
                    this.profileItem.push({
                        field: 'University',
                        value: this.dataUserVisit.university,
                    });
                }
                if (this.dataUserVisit.interested_in !== null && this.dataUserVisit.interested_in !== '' && this.dataUserVisit.interested_in !== 'default') {
                    this.profileItem.push({
                        field: 'Interested In',
                        value: this.dataUserVisit.interested_in,
                    });
                }
            } else { 
                this.bio.text = this.dataUser.bio;
                if (this.dataUser.origin_country !== null && this.dataUser.origin_country !== '') {
                    this.profileItem.push({
                        field: 'Origin Country',
                        value: this.dataUser.origin_country,
                    });
                }
                if (this.dataUser.passport_no !== null && this.dataUser.passport_no !== '') {
                    this.profileItem.push({
                        field: 'Passport No',
                        value: this.dataUser.passport_no,
                    });
                }
                if (this.dataUser.birthdate !== null && this.dataUser.birthdate !== '') {
                    if (this.dataUser.hide_birthdate !== 0) {
                        this.profileItem.push({
                            field: 'Birthdate',
                            value: moment(this.dataUser.birthdate, 'DD-MM-YYYY').format(),
                        });
                    }
                }
                if (this.dataUser.gender !== null && this.dataUser.gender !== '') {
                    if (this.dataUser.hide_gender !== 0) {
                        this.profileItem.push({
                            field: 'Gender',
                            value: this.dataUser.gender,
                        });
                    }
                }
                if (this.dataUser.phone_number !== null && this.dataUser.phone_number !== '') {
                    if (this.dataUser.hide_phone_number !== 0) {
                        this.profileItem.push({
                            field: 'Phone Number',
                            value: this.dataUser.phone_number,
                        });
                    }
                }
                if (this.dataUser.darmasiswa_academic_year !== null && this.dataUser.darmasiswa_academic_year !== '') {
                    this.profileItem.push({
                        field: 'Darmasiswa Academic Year',
                        value: this.dataUser.darmasiswa_academic_year,
                    });
                }
                if (this.dataUser.field_study !== null && this.dataUser.field_study !== '' && this.dataUser.field_study !== 'default') {
                    this.profileItem.push({
                        field: 'Field Study',
                        value: this.dataUser.field_study,
                    });
                }
                if (this.dataUser.university !== null && this.dataUser.university !== '') {
                    this.profileItem.push({
                        field: 'University',
                        value: this.dataUser.university,
                    });
                }
                if (this.dataUser.interested_in !== null && this.dataUser.interested_in !== '' && this.dataUser.interested_in !== 'default') {
                    this.profileItem.push({
                        field: 'Interested In',
                        value: this.dataUser.interested_in,
                    });
                }
            }

            const uniqueArray = this.profileItem.filter((profileItem, index) => {
                return index === this.profileItem.findIndex((obj) => {
                    return JSON.stringify(obj.field) === JSON.stringify(profileItem.field);
                });
            });
            this.profileItem = uniqueArray;
        },
        async updateProfile() {
            try {
                let payload = {
                    scope: 'updateProfile',
                    data: {
                        access_token: this.dataUser.access_token,
                        bio: this.bio.text,
                    },
                };

                let user = await this.$store.dispatch('user', payload);
                if (user.data.status) {
                    this.$bvToast.toast('Update Profile Success', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });

                    let dataUser = user.data.data; 
                    dataUser.access_token = user.data.access_token;
                    localStorage.setItem('dataUser', CryptoJS.AES.encrypt(JSON.stringify(dataUser), aes));
                    this.$store.commit('setDataUser');
                } else {
                    this.$bvToast.toast('Update Profile Failed!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.$bvToast.toast('Error occured please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async infiniteHandler($state) {
            this.page += 1;

            let payload;
            if (this.dataUserVisit !== null) {
                payload = {
                    scope: 'load',
                    data: {
                        access_token: this.dataUser.access_token,
                        user_id: this.dataUserVisit.id,
                        page: this.page,
                    },
                };
            } else {
                payload = {
                    scope: 'load',
                    data: {
                        access_token: this.dataUser.access_token,
                        user_id: this.dataUser.id,
                        page: this.page,
                    },
                };
            }

            try {
                let post = await this.$store.dispatch('post', payload);
                if (post.data.status) {
                    if (post.data.message.length > 0) {
                        post.data.message.forEach((m) => {
                            this.item.push(m);
                            this.formComment.push({status: ''});
                        });
                        $state.loaded();
                    } else {
                        this.page -= 1;
                        $state.complete();
                    }
                } else {
                    this.page -= 1;
                    $state.error();
                    if (post.data.message !== 'Invalid API Request') {
                        this.$bvToast.toast('Load Post Failed! Please Refresh the page!', {
                            title: 'Failed',
                            variant: 'warning',
                            autoHideDelay: 2000,
                        });
                    }
                }
            } catch (err) {
                this.page -= 1;
                $state.error();
                this.$bvToast.toast('Load Post Failed! Please Refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        showGallery(id) {
            this.images = [];
            this.index = 0;
            this.item.forEach((i) => {
                if (id === i.id) {
                    i.media.forEach((p) => {
                        if (p.type === 'photo') {
                            this.images.push(p.url);
                        }
                    });
                }
            });
        },
        personTagPill(name) {
            let p = JSON.parse(name);
            let html = ' - <i class="fa fa-users"></i> ';
            p.forEach((user) => {
                html += `<b-badge pill variant="primary">${user}</b-badge> `;
            });
            return html;
        },
        isLiked(postId, postIndex) {
            if (typeof this.item[postIndex].likes !== 'undefined') {
                let index = this.item[postIndex].likes.findIndex(el => el.user_id === this.dataUser.id);
                if (index !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async onLike(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Liking Post! Please Wait...';

            let payload = {
                scope: 'likePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let like = await this.$store.dispatch('post', payload);
                if (like.data.status) {
                    this.showLoading = false;

                    this.item[postIndex].likes = like.data.data.likes;

                    this.$bvToast.toast('Like Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Like Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Like Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onDisLike(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Disliking Post! Please Wait...';

            let payload = {
                scope: 'dislikePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let dislike = await this.$store.dispatch('post', payload);
                if (dislike.data.status) {
                    this.showLoading = false;

                    this.item[postIndex].likes.splice(this.item[postIndex].likes.findIndex(el => el.user_id === this.dataUser.id), 1);

                    this.$bvToast.toast('Dislike Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        isDisliked(postId, postIndex) {
            if (typeof this.item[postIndex].dislikes !== 'undefined') {
                let index = this.item[postIndex].dislikes.findIndex(el => el.user_id === this.dataUser.id);
                if (index !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async onDislike(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'dislikePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let dislike = await this.$store.dispatch('post', payload);
                if (dislike.data.status) {
                    this.showLoading = false;

                    this.item[postIndex].dislikes = dislike.data.data.dislikes;
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        toogleDialogEmojiComment(index) {
            if (this.dialogHiddenCommentID !== '' && this.dialogHiddenCommentID === index) {
                this.dialogHiddenCommentID = '';
            } else if (this.dialogHiddenCommentID !== index) {
                this.dialogHiddenCommentIDPinned = '';
                this.dialogHiddenCommentID = index;
            }
        },
        dialogHiddenComment(index) {
            if (this.dialogHiddenCommentID !== index) {
                return true;
            } 
            if (this.dialogHiddenCommentID === index) {
                return false;
            }
        },
        onSelectEmojiComment(dataEmoji) {
            this.formComment[this.dialogHiddenCommentID].status += dataEmoji.emoji;
        },
        async createComment(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Creating Comment! Please Wait...';

            let payload = {
                scope: 'createComment',
                data: {
                    access_token: this.dataUser.access_token,
                    status: this.formComment[postIndex].status,
                    post_id: postId,
                },
            };

            try {
                let comment = await this.$store.dispatch('post', payload);
                if (comment.data.status) {
                    this.formComment[postIndex].status = '';
                    this.showLoading = false;

                    this.item[postIndex].comments.push(comment.data.data);

                    this.$bvToast.toast('Create Comment Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Create Comment Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Create Comment Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onSharePost(id, name) {
            this.showLoading = true;
            this.labelLoading = 'Sharing ' + name + ' Post! Please Wait...';

            let payload = {
                scope: 'sharePost',
                data: {
                    access_token: this.dataUser.access_token,
                    shared_post_id: id
                },
            };

            try {
                let share = await this.$store.dispatch('post', payload);
                if (share.data.status) {
                    this.showLoading = false;

                    this.$bvToast.toast('Sharing Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Sharing Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Sharing Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        onCancelReport() {
            this.$bvModal.hide('modal-report');
            this.formReport.description = '';
            this.formReport.post_id = '';
        },
        onReport(id) {
            this.formReport.post_id = id;
        },
        async onSendReport() {
            this.showLoading = true;
            this.labelLoading = 'Reporting Post! Please Wait...';

            let payload = {
                scope: 'reportPost',
                data: {
                    access_token: this.dataUser.access_token,
                    post_id: this.formReport.post_id,
                    user_id: this.dataUser.id,
                    description: this.formReport.description
                },
            };

            try {
                let report = await this.$store.dispatch('post', payload);
                if (report.data.status) {
                    this.showLoading = false;

                    this.$bvModal.hide('modal-report');
                    this.formReport.description = '';
                    this.formReport.post_id = '';
                    this.page = 0;
                    this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                    this.item = [];
                    this.pinnedPost = [];
                    this.formComment = [];
                    this.formCommentPinned = [];

                    this.$bvToast.toast('Reporting Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvModal.hide('modal-report');
                    this.formReport.description = '';
                    this.formReport.post_id = '';
                    this.$bvToast.toast('Reporting Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvModal.hide('modal-report');
                this.formReport.description = '';
                this.formReport.post_id = '';
                this.$bvToast.toast('Reporting Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        isDislikedPinned(postId, postIndex) {
            if (typeof this.pinnedPost[postIndex].dislikes !== 'undefined') {
                let index = this.pinnedPost[postIndex].dislikes.findIndex(el => el.user_id === this.dataUser.id);
                if (index !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async onDislikePinned(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Disliking Post! Please Wait...';

            let payload = {
                scope: 'dislikePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let dislike = await this.$store.dispatch('post', payload);
                if (dislike.data.status) {
                    this.showLoading = false;

                    this.pinnedPost[postIndex].dislikes.splice(this.pinnedPost[postIndex].dislikes.findIndex(el => el.user_id === this.dataUser.id), 1);

                    // this.$bvToast.toast('Dislike Post Success!', {
                    //     title: 'Success',
                    //     variant: 'success',
                    //     autoHideDelay: 2000,
                    // });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async visitProfile(id, name) {
            this.showLoading = true;
            this.labelLoading = 'Visiting ' + name + ' Profile! Please Wait...';

            let payload = {
                scope: 'visitProfile',
                data: {
                    access_token: this.dataUser.access_token,
                    user_id: id
                },
            };

            try {
                let visit = await this.$store.dispatch('post', payload);
                if (visit.data.status) {
                    this.showLoading = false;

                    localStorage.setItem('visitProfileData', CryptoJS.AES.encrypt(JSON.stringify(visit.data.message), aes));
                    this.$router.push({name: 'visit-profile', params: { id: id, type: 'timeline' }});
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Visiting Profile Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Visiting Profile Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        onShare(id, name) {
            this.formShare.post_id = id;
            this.formShare.name = id;
        },
        onCancelShare() {
            this.$bvModal.hide('modal-share');
            this.formShare.status = '';
            this.formShare.name = '';
            this.formShare.post_id = '';
        },
        async mostDislikedPost() {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'mostDislikedPost',
                data: {
                    access_token: this.dataUser.access_token,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                this.showLoading = false;
                this.mostDislikedPostItem = post.data.message;
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Most Disliked Post Failed! Please Refresh the Page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async mostSharedPost() {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'mostSharedPost',
                data: {
                    access_token: this.dataUser.access_token,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                this.showLoading = false;
                this.mostSharedPostItem = post.data.message;
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Most Shared Post Failed! Please Refresh the Page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onShareConfirm() {
            this.showLoading = true;
            this.labelLoading = 'Sharing ' + name + ' Post! Please Wait...';

            let payload = {
                scope: 'sharePost',
                data: {
                    access_token: this.dataUser.access_token,
                    status: this.formShare.status,
                    shared_post_id: this.formShare.post_id
                },
            };

            try {
                let share = await this.$store.dispatch('post', payload);
                if (share.data.status) {
                    this.showLoading = false;

                    this.$bvModal.hide('modal-share');
                    this.formShare.status = '';
                    this.formShare.post_id = '';
                    this.formShare.name = '';
                    this.page = 0;
                    this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                    this.item = [];
                    this.pinnedPost = [];
                    this.formComment = [];
                    this.formCommentPinned = [];

                    this.$bvToast.toast('Sharing Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Sharing Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Sharing Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        toTimeline(){
            if (typeof this.$route.params.id !== 'undefined') {
                this.$router.push({name: 'visit-profile', params: { id: this.$route.params.id, type: 'timeline' }});
            } else {
                this.$router.push({name: 'profile', params: { type: 'timeline' }});
            }
        },
        toPhotos(){
            if (typeof this.$route.params.id !== 'undefined') {
                this.$router.push({name: 'visit-profile', params: { id: this.$route.params.id, type: 'photos-videos' }});
            } else {
                this.$router.push({name: 'profile', params: { type: 'photos-videos' }});
            }
        },
        async onGetAsset() {
            let payload;
            if (this.dataUserVisit !== null) {
                payload = {
                    scope: 'getAsset',
                    data: {
                        access_token: this.dataUser.access_token,
                        user_id: this.dataUserVisit.id,
                    },
                };
            } else {
                payload = {
                    scope: 'getAsset',
                    data: {
                        access_token: this.dataUser.access_token,
                        user_id: this.dataUser.id,
                    },
                };
            }

            try {
                let asset = await this.$store.dispatch('post', payload);
                if (asset.data.status) {
                    this.showLoading = false;

                    if (asset.data.message.photos.length > 0) {
                        asset.data.message.photos.forEach((p) => {
                            this.assetImage.push(p.url);
                        });
                    }
                    this.assetVideo = asset.data.message.videos;

                    this.$bvToast.toast('Getting Photos & Videos Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Getting Photos & Videos Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Getting Photos & Videos Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onDeletePost(id) {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'deletePost',
                data: {
                    access_token: this.dataUser.access_token,
                    post_id: id,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                this.showLoading = false;
                this.page = 0;
                this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                this.item = [];
                this.pinnedPost = [];
                this.formComment = [];
                this.formCommentPinned = [];
                this.$bvToast.toast('Delete Post Success!', {
                    title: 'Success',
                    variant: 'success',
                    autoHideDelay: 2000,
                });
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Delete Post Failed! Please Refresh the Page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
    }
}
</script>

<style scoped>
    .image {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
    }
    .profile__more-info {
        float: none !important;
        display: inline-block !important;
    } 
    .emojiPicker {
        position: absolute;
        left: 220%;
        z-index: 9999;
    }

    .modal-dialog {
        margin-top: 10rem auto !important;
    }
</style>
